import React, { useState } from "react";
import ReactSwitch from "react-switch";
import { isMobileView } from "./CommonFunctions";
import Icon from "../../assets/icons/Icon";

const CustomSwitch = ({
  formlabel,
  onChange,
  checked = false,
  errorMessage,
  infoText,
  tooltipPosition = "bottom",
  tooltipOffset = "0",
  tooltipWidth = null, // Now accepts direct width value like "600px"
  disabled,
  isMandatory
}) => {
  const [showInfoText,setShowInfoText]=useState(false);
  return (
    <div className="flex flex-col min-w-[120px]">
      <label
        style={{
          fontFamily: "Inter,Source Sans Pro, Helvetica, Arial, sans-serif",
        }}
        className={`mb-1   inline-flex items-center gap-1
          ${errorMessage ? "text-red-700" : "text-[#000000b4]"}
         `}
      >
         {formlabel} {isMandatory && <span className="text-red-700">*</span>}
        {infoText && (
                  <div className="relative inline-flex group self-start mt-1">
                    <span onClick={()=>{setShowInfoText(!showInfoText)}} onMouseEnter={()=>{setShowInfoText(true)}} onMouseLeave={()=>{setShowInfoText(false)}} className="inline-flex items-center justify-center ml-1 border border-[rgb(108,113,138)] text-[rgb(108,113,138)] rounded-full w-4 h-4 text-center leading-4 text-xs cursor-pointer">
                      i
                    </span>
      {showInfoText && (
        <div
          className={`
            z-50 px-3 py-2 rounded whitespace-normal
            ${isMobileView()
              ? `fixed left-0 justify-center flex w-full bg-[#4A1E73] text-[#FFFFFF] top-0 }`
              : `
                absolute bg-[#4A1E73] text-[#FFFFFF] 
                ${getTooltipPositionClasses(tooltipPosition)}
                ${tooltipOffset ? `m-${tooltipOffset}` : ""}
              `
            }
          `}
          style={{
            width: isMobileView() ? "100%" : tooltipWidth || undefined,
          }}
        >
          {isMobileView() && (
            <span
              className="absolute top-2 right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center cursor-pointer shadow-lg hover:bg-red-600 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                setShowInfoText(false);
              }}
              aria-label="Close tooltip"
            >
              <span className="w-4">
                <Icon type="remove" />
              </span>
            </span>
          )}
          {infoText}
        </div>
      )}
      
                  </div>
                )}
      </label>
      <ReactSwitch
        disabled={disabled}
        onChange={onChange}
        checked={checked}
        className="react-switch"
      />

      <label
        style={{
          fontFamily: "Inter,Source Sans Pro, Helvetica, Arial, sans-serif",
        }}
        className={`mb-1   inline-flex items-center gap-1
          ${errorMessage ? "text-red-700" : "text-[#000000]"}
         `}
      >
        {errorMessage}
      </label>
    </div>
  );
};
// Positioning helper remains the same
const getTooltipPositionClasses = (position) => {
  switch (position) {
    case "top":
      return "bottom-full left-1/2 -translate-x-1/2 mb-2";
    case "bottom":
      return "top-full left-1/2 -translate-x-1/2 mt-2";
    case "left":
      return "right-full top-1/2 -translate-y-1/2 mr-2";
    case "right":
      return "left-full top-1/2 -translate-y-1/2 ml-2";
    default:
      return "bottom-full left-1/2 -translate-x-1/2 mb-2";
  }
};
export default CustomSwitch;

// Background: #D6AEDD (Light Lavender) | Text: #FFFFFF (White)

// Background: #4A1E73 (Dark Purple) | Text: #FFFFFF (White)

// Background: #B5B5B5 (Light Gray) | Text: #6E2D90 (Purple for a consistent theme)
